import React from 'react';
import { View, ActivityIndicator, StyleSheet } from 'react-native';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../lib/contexts/AuthContext';
import { ComensalLocationGate } from './ComensalLocationGate';
import { ComensalBottomTabBar } from './ComensalBottomTabBar';

/**
 * App nativa autenticada: comprobación de ubicación antes del home.
 */
export function ComensalAppRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#030213" />
      </View>
    );
  }

  if (!user) {
    return <Navigate to="/entrar" replace />;
  }

  return (
    <ComensalLocationGate>
      <View style={styles.shell}>
        <View style={styles.outletWrap}>
          <Outlet />
        </View>
        <View style={[styles.tabBarDock, { pointerEvents: 'box-none' }]}>
          <ComensalBottomTabBar />
        </View>
      </View>
    </ComensalLocationGate>
  );
}

const styles = StyleSheet.create({
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  shell: {
    flex: 1,
    minHeight: 0,
    position: 'relative',
  },
  outletWrap: {
    flex: 1,
    minHeight: 0,
  },
  tabBarDock: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },
});
